import React from "react";
import { useFormContext } from "react-hook-form";
import { Field, FieldType, UserData } from "../types";
import { FormField } from "./FormField";

interface InviteFormProps {
    fields: Field[];
    disabledFields: Record<string, boolean>;
    onUserSelected: (user: UserData) => void;
    onSubmit: (data: any) => Promise<void>;
    formId: string;
}

/**
 * Dedicated component for rendering and handling the invite user form logic.
 */
export const InviteForm: React.FC<InviteFormProps> = ({ fields, disabledFields, onUserSelected, onSubmit, formId }) => {
    const methods = useFormContext();

    return (
        <form id={formId} onSubmit={methods.handleSubmit(onSubmit)}>
            {/* Render each form field */}
            {fields.map((field) => {
                if (field.type === FieldType.EMAIL_AUTOCOMPLETE) {
                    return (
                        <FormField
                            key={field.id}
                            disabled={disabledFields[field.id]}
                            onUserSelected={onUserSelected}
                            {...field}
                        />
                    );
                }

                return <FormField key={field.id} disabled={disabledFields[field.id]} {...field} />;
            })}
        </form>
    );
};
